import * as THREE from 'three';
import { MojisLine } from './MojisLine';
import { MojisDotRender } from './MojisDotRender';
import { DataManager } from '../data/DataManager';
import { ConnectingDotsRender } from './ConnectingDotsRender';
import { Params } from '../data/Params';
import { MojiDot } from './MojiDot';
import { ScreenSize } from '../data/ScreenSize';

export class MojisLines extends THREE.Object3D{

    dotRenderer     :MojisDotRender;
    connectingRenderer:ConnectingDotsRender;
    //outlineRenderer  :OutlineRender;
    lines           :MojisLine[];
    //timeline        :Timeline;
    count           :number = 0;
    dataManager     :DataManager;
    isPause         :boolean = false;
    private allEnabledDots  :MojiDot[];
    private allDots         :MojiDot[];

    init(){

        this.dataManager = DataManager.getInstance();
        this.dotRenderer = MojisDotRender.getInstance();
        this.connectingRenderer = ConnectingDotsRender.getInstance();
        this.dataManager.gui?.add(this,"isPause")
        
        this.lines=[
            new MojisLine(),
            new MojisLine(),
            new MojisLine(),
            new MojisLine(),
            new MojisLine(),
            new MojisLine(),
            new MojisLine(),
            new MojisLine()                
        ];

        for(let i=0;i<this.lines.length;i++){
            this.lines[i].init(-i,i);
            this.add(this.lines[i]);
        }

    }

    tween(){
        for(let i=0;i<this.lines.length;i++){
            this.lines[i].tween();
        }
    }

    
    //0,1,2,3,4
    changeNum(n:number,n2:number){

        let list:number[] = [
            16,8,4,2,1
        ];
        let num = list[n];
        let num2 = list[n2];
        for(let i=0;i<this.lines.length;i++){
            
            if(i%2==0) this.lines[i].setDotsNum(num);
            else this.lines[i].setDotsNum(num2);

        }

    }

    boost(){
        this.connectingRenderer.blink();
        for(let i=0;i<this.lines.length;i++){
            this.lines[i].boost();
        }
    }

    blink(){
        for(let i=0;i<this.lines.length;i++){
            this.lines[i].blink();
        }
    }

    blinkBg(ratio:number){
        if(ratio<0)ratio=0;
        if(ratio>1)ratio=1;

        for(let i=0;i<this.lines.length;i++){
            this.lines[i].blinkBg(ratio);
        }
    }

    getAllDots():MojiDot[]{
        this.allDots=[];
        for(let i=0;i<this.lines.length;i++){
            this.allDots = this.allDots.concat(
                this.lines[i].getAllDots()
            );
        }
        return this.allDots;
    }

    setAllEnabled(b:boolean){
        for(let i=0;i<this.lines.length;i++){
            this.lines[i].setAllEnabled(b);
        }
    }

    showLogoBg(brightness:number){
        for(let i=0;i<this.lines.length;i++){
            this.lines[i].showBgLogo(brightness);
        }
    }
    hideLogoBg(){
        for(let i=0;i<this.lines.length;i++){
            this.lines[i].hideBgLogo();
        }
    }

    getAllEnabledDots():MojiDot[]{
        this.allEnabledDots=[];

        for(let i=0;i<this.lines.length;i++){
            this.allEnabledDots = this.allEnabledDots.concat(
                this.lines[i].getEnabledDots()
            );
        }

        return this.allEnabledDots;
    }

    update(){
        
        this.connectingRenderer.reset();
        this.allEnabledDots=[];

        for(let i=0;i<this.lines.length;i++){
            this.lines[i].update();
            

            if(!this.isPause){
                this.lines[i].position.y+=1;
                if(this.lines[i].position.y>200*4){
                    this.lines[i].position.y=-200*4
                }    
            }
        }

        this.dotRenderer.update();

        this.connectingRenderer.update();

    }

    resize(){

        this.dotRenderer.resize();

        if(ScreenSize.isWideScreen()){
            //ずらさない 
            for(let i=0;i<this.lines.length;i++){
                this.lines[i].position.x=Params.LINE_OFFSET_X;//i/this.lines.length*100;
            }
        }else{
            //ずらす
            let camera = this.dataManager.camera;
            let startX = camera.left;
            let width = Math.abs(startX)*2;//cameraWidth
            let zurashi = Params.LOGO_WIDTH - width;
            for(let i=0;i<this.lines.length;i++){
                let ratio = 1 - i / (this.lines.length-1);
                //this.lines[i].position.x = startX + Params.LOGO_WIDTH/2;
                this.lines[i].position.x = zurashi/2 - zurashi * ratio;
            
                //this.lines[i].position.x = -zurashi/2;
            }
        }

    
    }

}

// {MojisLines};